import { cn, NoddiIcon } from 'noddi-ui-common';
import { ChangeEvent } from 'react';
import { NoddiInput } from '../../../Inputs/NoddiInput';

interface Props {
  handleChange: (e: ChangeEvent<HTMLInputElement>) => void;
  placeholder?: string;
  defaultValue?: string;
}

export const NoddiSearchBar = ({ handleChange, placeholder, defaultValue }: Props) => (
  <NoddiInput
    placeholder={placeholder}
    defaultValue={defaultValue}
    onChange={(e: ChangeEvent<HTMLInputElement>) => handleChange(e)}
    startAdornment={<NoddiIcon className={cn('text-muted-foreground')} name='Search' size='small' />}
  />
);
